<template lang="pug">
	.v-bonus.bonus(v-if="data" :class="`bonus--${data.color}`")
		.bonus__container.container
			.bonus__wrap
				.bonus__left
					v-svg-icon.bonus__icon(v-if="data.icon" :icon="data.icon" :class="`bg-banner__right-bottom-bonus_icon--${data.iconBgColor}`")
					.bonus__title(v-if="data.title" v-html="data.title")
				.bonus__right
					.bonus__items(v-if="data.items")
						.bonus__item(
							v-for="(item, index) of data.items"
							:key="index"
							:class="`bonus__item--${item.color}`"
						)
							h3.bonus__item-title(v-if="item.title" v-html="item.title")
							span.bonus__item-text(v-if="item.text" v-html="item.text")

</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null,
		};
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
};
</script>